import { useQuery } from '@apollo/client';
import { Stadium } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router-dom';
import { AuditLogList } from '~/components/AuditLogs';
import { RouterBreadcrumbs } from '~/components/RouterBreadcrumbs';
import { ScrollableRouterTabs } from '~/components/RouterTabs';
import { PageContainer } from '~/components/page-layout';
import { Toolbar } from '~/components/toolbar';
import { useAppContext } from '~/contexts';
import { useLink } from '~/hooks/link';
import { NetworkEventTypeAuditLogsDocument } from '../queries/AuditLogs.generated';
import { useTabs } from './lib/tabs';

export const EventTypeAuditLogs = () => {
  const { t } = useTranslation();
  const params = useParams<{ eventTypeId: string }>();
  const eventTypeId = parseInt(params.eventTypeId ?? '');

  const { currentNetwork } = useAppContext();
  const link = useLink();

  const tabs = useTabs();

  const { data, loading } = useQuery(NetworkEventTypeAuditLogsDocument, {
    variables: { networkId: currentNetwork.id, eventTypeId },
  });

  const eventType = data?.network?.eventType;

  if (loading || !eventType) return !loading ? <Navigate to={link('/not-found')} replace /> : null;

  return (
    <>
      <Toolbar
        breadcrumbsLabel={<RouterBreadcrumbs />}
        titleIcon={<Stadium />}
        titleText={eventType.name}
      />

      <ScrollableRouterTabs current={t('common.tabs.audit_logs')} tabs={tabs} />

      <PageContainer>
        <AuditLogList recordTypes={['EventType']} eventTypeId={eventTypeId} />
      </PageContainer>
    </>
  );
};
